/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

type SubmitCBQSessionResult = {
  error?: ApiError | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
};

// POST /cbq/sessions/:cbqSessionId/submit — score all questions. Idempotent.
export const SubmitCBQSession = async (
  cbqSessionId: string
): Promise<SubmitCBQSessionResult> => {
  try {
    const response = await axios.post(`/cbq/sessions/${cbqSessionId}/submit`);
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
